var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36554 0.843444C9.654 1.1319 9.68022 1.58329 9.44421 1.90136L9.36554 1.99249L2.3571 9.0013L9.36554 16.0101C9.65399 16.2986 9.68022 16.75 9.44421 17.068L9.36554 17.1592C9.07708 17.4476 8.6257 17.4738 8.30762 17.2378L8.21649 17.1592L0.633158 9.57582C0.344703 9.28737 0.31848 8.83598 0.554488 8.5179L0.633158 8.42678L8.21649 0.843444C8.53379 0.526143 9.04824 0.526143 9.36554 0.843444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.9d3d4cf68ddc83e59b8e66b673a8eb33.svg";
export { ForwardRef as ReactComponent };